// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","homepageLayout":"LT5Ln","homepageBrandValue":"dhRvW"};